import React, { ReactElement } from 'react'
import { Box, Text } from '@mindfulchefuk/design-system'

type TOnboardingRecipeSnippet = {
  /** The heading of the snippet */
  title: string
  /** The description of the snippet */
  description?: string
  /** The subtext of the snippet */
  subtext?: string
  /** What row of the grid the snippet should be on */
  row: number
  id: string
}

export const OnboardingRecipeSnippet = ({
  title,
  description,
  subtext,
  row,
  id,
}: TOnboardingRecipeSnippet): ReactElement => {
  return (
    <Box
      bg="salt"
      gridRow={row}
      gridColumn="1 / -1"
      p={20}
      px={{ base: 20, md: 32 }}
      textAlign="center"
      as="li"
      id={id}
    >
      <Text
        variant="body-xl-500"
        color="aubergine"
        as="h3"
        my={!description && !subtext ? 6 : 0}
        id={`${id}-title`}
      >
        {title}
      </Text>
      {description && (
        <Text
          variant="body-lg"
          as="p"
          mt={6}
          id={`${id}-description`}
          color="aubergine"
        >
          {description}
        </Text>
      )}
      {subtext && (
        <Text
          variant="body-sm"
          as="p"
          mt={6}
          id={`${id}-subtext`}
          color="aubergine"
        >
          {subtext}
        </Text>
      )}
    </Box>
  )
}
